<template>
    <v-container fluid v-if="azienda">
        <v-row class="align-center mb-2">
            <v-col cols="auto">
                <h2 class="text-h6">{{ azienda.ragioneSociale }}</h2>
            </v-col>
            <v-col cols="auto">
                <v-chip size="small" :color="azienda.attivo ? 'success' : 'grey'" variant="flat">
                    {{ azienda.attivo ? 'Attiva' : 'Disattivata' }}
                </v-chip>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialogUtente(null)">Nuovo utente</v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="utenti" :items-per-page="15" density="comfortable">
            <template #[`item.isDeleted`]="{ item }">
                <v-chip size="small" :color="item.isDeleted ? 'grey' : 'success'" variant="flat">
                    {{ item.isDeleted ? 'Disabilitato' : 'Attivo' }}
                </v-chip>
            </template>
            <template #[`item.azioni`]="{ item }">
                <v-btn icon variant="text" size="small" @click="apriDialogUtente(item)" title="Modifica">
                    <v-icon size="small">mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" @click="apriDialogPassword(item)" title="Reset password">
                    <v-icon size="small">mdi-lock-reset</v-icon>
                </v-btn>
                <v-btn v-if="!item.isDeleted" icon variant="text" size="small" color="error" @click="disabilita(item)"
                    title="Disabilita">
                    <v-icon size="small">mdi-account-off</v-icon>
                </v-btn>
                <v-btn v-else icon variant="text" size="small" color="success" @click="abilita(item)" title="Riabilita">
                    <v-icon size="small">mdi-account-check</v-icon>
                </v-btn>
                <v-btn v-if="!item.isDeleted" icon variant="text" size="small" color="warning"
                    @click="apriDialogImpersona(item)" title="Accedi come questo utente">
                    <v-icon size="small">mdi-incognito</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <!-- Dialog utente -->
        <v-dialog v-model="dialogUtente" max-width="800" :fullscreen="isMobile">
            <v-card>
                <v-card-title>{{ formUtente.userId ? 'Modifica utente' : 'Nuovo utente' }}</v-card-title>
                <v-card-text>
                    <v-form ref="formUtenteRef">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="formUtente.username" label="Username"
                                    :disabled="!!formUtente.userId" :rules="[v => !!v || 'Obbligatorio']" />
                            </v-col>
                            <v-col cols="12" sm="6" v-if="!formUtente.userId">
                                <v-text-field v-model="formUtente.password" type="password"
                                    label="Password provvisoria"
                                    :rules="[v => (!!v && v.length >= 8) || 'Almeno 8 caratteri']" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="formUtente.displayName" label="Nome visualizzato" />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="formUtente.eMail" label="Email" />
                            </v-col>
                        </v-row>
                        <v-select v-model="formUtente.roleID" :items="ruoliDisponibili" item-title="label"
                            item-value="value" label="Ruolo" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogUtente = false">Annulla</v-btn>
                    <v-btn color="primary" @click="salvaUtente">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog reset password -->
        <v-dialog v-model="dialogPassword" max-width="420">
            <v-card>
                <v-card-title>Reset password — {{ utenteSelezionato?.username }}</v-card-title>
                <v-card-text>
                    <v-text-field v-model="nuovaPassword" type="password" label="Nuova password provvisoria"
                        :rules="[v => (!!v && v.length >= 8) || 'Almeno 8 caratteri']" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogPassword = false">Annulla</v-btn>
                    <v-btn color="primary" @click="confermaResetPassword">Conferma</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog impersona -->
        <v-dialog v-model="dialogImpersona" max-width="420">
            <v-card>
                <v-card-title>Accedi come {{ utenteSelezionato?.username }}</v-card-title>
                <v-card-text>
                    <p class="text-body-2 mb-3">
                        L'accesso verrà registrato (data, ora, motivo) a fini di audit.
                        La sessione dura al massimo 20 minuti.
                    </p>
                    <v-textarea v-model="motivoImpersona" label="Motivo dell'accesso" rows="2"
                        :rules="[v => !!v || 'Obbligatorio']" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogImpersona = false">Annulla</v-btn>
                    <v-btn color="warning" @click="confermaImpersona">Accedi come utente</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
    <v-container v-else>
        <v-progress-circular indeterminate color="primary" />
    </v-container>
</template>

<script>
export default {
    name: "AziendaDettaglioPage",

    props: {
        id: { type: [String, Number], required: true },
    },

    data() {
        return {
            headers: [
                { title: "Username", key: "username" },
                { title: "Nome", key: "displayName" },
                { title: "Email", key: "eMail" },
                { title: "Ruolo", key: "roleID" },
                { title: "Stato", key: "isDeleted" },
                { title: "", key: "azioni", sortable: false },
            ],
            ruoliDisponibili: [
                { label: "Admin", value: "Admin" },
                { label: "Operatore", value: "Operatore" },
                { label: "Visualizzatore", value: "Visualizzatore" },
            ],
            dialogUtente: false,
            formUtente: this.formUtenteVuoto(),
            dialogPassword: false,
            dialogImpersona: false,
            utenteSelezionato: null,
            nuovaPassword: "",
            motivoImpersona: "",
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
        azienda() {
            return this.$store.getters["aziende/corrente"];
        },
        utenti() {
            return this.$store.getters["utentiAdmin/lista"];
        },
    },

    mounted() {
        this.carica();
    },

    methods: {
        carica() {
            this.$store.dispatch("aziende/caricaDettaglio", this.id);
            this.$store.dispatch("utentiAdmin/carica", this.id);
        },

        formUtenteVuoto() {
            return { userId: null, username: "", password: "", displayName: "", eMail: "", roleID: "Operatore" };
        },

        apriDialogUtente(item) {
            this.formUtente = item
                ? {
                    userId: item.userId,
                    username: item.username,
                    password: "",
                    displayName: item.displayName,
                    eMail: item.eMail,
                    roleID: item.roleID,
                }
                : this.formUtenteVuoto();
            this.dialogUtente = true;
        },

        async salvaUtente() {
            if (!this.$refs.formUtenteRef.validate()) return;
            try {
                const { userId, ...dati } = this.formUtente;
                if (!userId) dati.aziendaId = Number(this.id);
                await this.$store.dispatch("utentiAdmin/salva", { id: userId, dati, aziendaId: this.id });
                this.dialogUtente = false;
            } catch (error) {
                console.log(error);
            }
        },

        apriDialogPassword(item) {
            this.utenteSelezionato = item;
            this.nuovaPassword = "";
            this.dialogPassword = true;
        },

        async confermaResetPassword() {
            if (!this.nuovaPassword || this.nuovaPassword.length < 8) return;
            try {
                await this.$store.dispatch("utentiAdmin/resetPassword", {
                    id: this.utenteSelezionato.userId,
                    nuovaPassword: this.nuovaPassword,
                });
                this.dialogPassword = false;
            } catch (error) {
                console.log(error);
            }
        },

        async abilita(item) {
            try {
                await this.$store.dispatch("utentiAdmin/abilita", { id: item.userId, aziendaId: this.id });
            } catch (error) {
                console.log(error);
            }
        },

        async disabilita(item) {
            try {
                await this.$store.dispatch("utentiAdmin/disabilita", { id: item.userId, aziendaId: this.id });
            } catch (error) {
                console.log(error);
            }
        },

        apriDialogImpersona(item) {
            this.utenteSelezionato = item;
            this.motivoImpersona = "";
            this.dialogImpersona = true;
        },

        async confermaImpersona() {
            console.log(this.utenteSelezionato.userId)
            if (!this.motivoImpersona) return;
            try {
                const resp = await this.$store.dispatch("utentiAdmin/impersona", {
                    id: this.utenteSelezionato.userId,
                    motivo: this.motivoImpersona,
                });
                // Da qui in poi la pagina viene ricaricata da avviaImpersonificazione
                await this.$store.dispatch("auth/avviaImpersonificazione", resp.data);
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>